export const toTitleCase = (str: string) => {
    const word = str.toLowerCase().split(' ');

    for (let i = 0; i < word.length; i++) {
        if (word[i]) {
            word[i] = word[i].charAt(0).toUpperCase() + word[i].slice(1);
        }
    }
    let titleCaseStr = word.join(' ');
    return titleCaseStr;
}